// ------------------------------------------------------ ARTICLE //

// --------------------------- Download //
$('body').on('click', '.download', function() {
	const id = $(this).data('id');
	const fileName = $(this).data('file');

	const href = `${s3}/${id}/${fileName}`;
	forceDownload(href, fileName);

	return false;
});
